export default "__VITE_ASSET__y2a4pG6C__"